// A feature line on an order bump card leads with the icon the seller picked;
// unset, it leads with this check. `none` is the seller switching the icon
// off: a plain line of text. Unset cannot mean that, since the public API
// documents it as "leads with a check".
export const DEFAULT_FEATURE_ICON = 'check-circle';
export const NO_FEATURE_ICON = 'none';
